import Vue from 'vue'
import VueRouter from 'vue-router'

import Auth from "@/layouts/Auth.vue";
import Admin from "@/layouts/Admin.vue";

// views for Auth layout
import Login from "@/views/auth/Login.vue";
import Register from "@/views/auth/Register.vue";

// views for Admin layout
import Dashboard from "@/views/admin/Dashboard.vue";
import Settings from "@/views/admin/Settings.vue";
import Tables from "@/views/admin/Tables.vue";
import Maps from "@/views/admin/Maps.vue";
import Airline from "@/views/admin/Airline.vue";
import Documentation from "@/views/admin/Documentation.vue";

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
//   base: process.env.BASE_URL,
  scrollBehavior (to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    } else {
      return { x: 0, y: 0, behavior: 'smooth' }
    }
  },
  routes: [
    {
      name: 'Auth',
      path: "/",
      redirect: "/auth/login",
      component: Auth,
      children: [
        {
          name: 'Login',
          path: "/auth/login",
          component: Login,
        //   beforeEnter: guardMyroute,
        },
        {
          name: 'Register',
          path: "/auth/register",
          component: Register,
        //   beforeEnter: guardMyroute,
        },
      ],
    },
    {
      path: "/admin",
      redirect: "/admin/dashboard",
      component: Admin,
      beforeEnter: guardMyroute,
      children: [
        {
          name: 'Dashboard',
          path: "/admin/dashboard",
          component: Dashboard,
        },
        {
          name: 'Airline',
          path: "/admin/airline",
          component: Airline,
        },
        {
          name: 'Documentation',
          path: "/admin/documentation",
          component: Documentation,
        },
        {
          name: 'Settings',
          path: "/admin/settings",
          component: Settings,
        },
        {
          name: 'Tables',
          path: "/admin/tables",
          component: Tables,
        },
        {
          name: 'Maps',
          path: "/admin/maps",
          component: Maps,
        },
      ],
    },
  ],
})

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user')
  // const user = JSON.parse(loggedIn)

  if (to.matched.some(record => record.meta.auth) && !loggedIn) {
    next('/')
    return
  }
  if (['Login', 'Register'].includes(to.name) && loggedIn) {
    next('/admin/dashboard')
    return
  }
  next()
})

function guardMyroute (to, from, next) {
  var isAuthenticated = false
  const staffPage = [
    'Dashboard',
    'Grade',
    'Tahfidz',
    'Lain lain',
    'Report Grade Student',
    'Report Grade Subject',
    'Report Grade Class',
  ]

  const studentPage = [
    'Dashboard',
    'Report Grade Student',
  ]

  if (localStorage.getItem('user')) {
    isAuthenticated = true
  } else {
    isAuthenticated = false
  }

  if (isAuthenticated) {
    const user = JSON.parse(localStorage.getItem('user'))
    // console.log(to.name)

    if (user.role === 'staff' && !staffPage.includes(to.name)) {
      // next('/academic/grade')
      next('/dashboard')
    } else if (user.role === 'student' && !studentPage.includes(to.name)) {
      next('/dashboard')
    } else {
      next() // allow to enter route
    }
  } else {
    next('/') // go to '/login';
  }
}

export default router
